<template>
  <div class="header">
    <div class="content common-justify-between common-flex">
      <div class="common-flex">
        <img class="logo" src="../assets/images/logotm.png" alt="" />
        <div class="common-flex menus">
          <div
            class="menu-item common-hover"
            @click="toRouter(item, index)"
            :class="nowRouter == item.router ? 'menu-item-choose' : ''"
            v-for="(item, index) in $t('header.menu')"
            :key="index"
            :style="[
              menuList.indexOf(item.code) > -1 ? {} : { display: 'none' },
              item.router == './styleProduct'
                ? { width: '100px', marginTop: '16px', textAlign: 'center' }
                : {},
            ]"
          >
            <!-- item.router=='./styleProduct'?{width:'110px',textAlign:'center'}:{} -->
            <!-- item.router=='./styleProduct'?{width:'140px',marginTop:'16px',textAlign:'center'}:{} -->
            <!-- :style="[menuList.indexOf(item.code)>-1?{}:{display:'none'}]" -->
            <!-- @mouseleave="leaveProduct(item, index)"
            @mouseenter="enterProduct(item, index)" -->
            <Poptip
              ref="poptipRef"
              v-if="item.name == 'NEW ORDER' && $store.state.user.login"
              trigger="hover"
              :width="fullWidth - 10"
              :disabled="productType.length > 0 ? false : true"
              :transfer="true"
            >
              <span>{{ item.name }}</span>
              <div slot="content">
                <div class="header-product">
                  <div class="product-type common-flex common-justify-center">
                    <div
                      class="common-hover"
                      :class="productTypeId == item.id ? 'product-typ-item' : ''"
                      v-for="(item, index) in productType"
                      :key="index"
                      @click="chooseType(item)"
                      :style="[
                        menuList.indexOf(item._code) > -1 ? {} : { display: 'none' },
                      ]"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                  <div
                    :class="product.length <= 8 ? 'common-justify-center' : ''"
                    class="common-flex product-list common-flex-wrap"
                  >
                    <div
                      class="product-list-item common-hover"
                      v-for="(item, index) in product"
                      :key="index"
                      @click="chooseProduct(item)"
                    >
                      <div
                        class="img-box"
                        :style="[
                          productId == item.id
                            ? { background: '#E7EDFA' }
                            : { background: '#F8F8F8' },
                        ]"
                      >
                        <img
                          :style="[
                            productId == item.id
                              ? { background: '#E7EDFA' }
                              : { background: '#F8F8F8' },
                          ]"
                          :src="item.imagePath"
                          alt=""
                        />
                      </div>
                      <div
                        class="product-name"
                        :style="[productId == item.id ? { color: '#0A4DCC' } : {}]"
                      >
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Poptip>
            <Poptip
              v-else-if="item.name == 'ORDER LIST' && $store.state.user.login"
              trigger="hover"
              :transfer="true"
            >
              <Badge
                v-if="item.name == 'ORDER LIST' && failedNum && failedNum['10369']"
                type="error"
                :count="failedNum['10369']"
              >
                <span>{{ item.name }}</span>
              </Badge>
              <span v-else>{{ item.name }}</span>
              <!-- <div slot="title"><i>Custom title</i></div> -->
              <div slot="content">
                <div>
                  <div
                    class="order-status-list"
                    :style="[orderStatus == item.id ? { color: '#0a4dcc' } : {}]"
                    @click="changeOrderStatus(item)"
                    v-for="(item, index) in orderStatusList"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </Poptip>

            <!-- <span v-else>{{ item.name }}</span> -->
            <span v-else>
              <Badge
                v-if="item.name == 'PENDING' && failedNum && failedNum['10371']"
                type="warning"
                :count="failedNum['10371']"
              >
                <span>{{ item.name }}</span>
              </Badge>

              <span v-else>
                <span>{{ item.name }}</span>
                <!-- <span v-if="item.router!='./styleProduct'">{{ item.name }}</span>
              <img v-else style="width: 70px;" src="../assets/images/lb1.gif" alt="" srcset=""> -->
              </span>
            </span>
            <!-- <span v-else>{{ item.name }}<span>{{ failedNum }}</span></span> -->
            <div v-if="nowRouter == item.router" class="menu-item-line"></div>
          </div>
        </div>
      </div>
      <div
        style="margin-right: 40px; margin-left: 40px"
        class="common-flex common-align-center"
      >
        <div
          class="iconfont iconxiaoxi message common-hover"
          v-if="$store.state.user.login"
          @click="message"
        ></div>
        <!-- <div
          class="common-hover iconfont icongouwuche cart"
          @click="goCart"
          :style="[menuList.indexOf('saveItems') > -1 ? {} : { display: 'none' }]"
        ></div> -->
        <img
          class="message-jjq cart common-hover"
          @click="taximeter"
          v-if="$store.state.user.login"
          src="../assets/images/jjq.png"
          alt=""
        />
        <Dropdown @on-click="handleLoginout">
          <img
            class="user common-hover"
            @click="toUser"
            src="../assets/images/defaultHeader.png"
            alt=""
          />
          <DropdownMenu slot="list">
            <DropdownItem name="loginout">Log Out</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!-- <div style="margin-left:30px;width:23px;height23px" >
          <Poptip v-model="visible" trigger="hover">
            <div slot="content">
              <p class="common-hover" @click="logOut">{{$t('login.logOut')}}</p>
            </div>
          </Poptip>
        </div> -->
      </div>
    </div>

    <!-- <div
      v-if="productShow"
      @mouseleave="leaveProduct(1, 1)"
      @mouseenter="enterProduct(1, 1)"
      class="header-product"
    >
      <div class="product-type common-flex common-justify-center">
        <div
          class="common-hover"
          :class="productTypeId == item.id ? 'product-typ-item' : ''"
          v-for="(item, index) in productType"
          :key="index"
          @click="chooseType(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        :class="product.length <= 8 ? 'common-justify-center' : ''"
        class="common-flex product-list common-flex-wrap"
      >
        <div
          class="product-list-item common-hover"
          v-for="(item, index) in product"
          :key="index"
          @click="chooseProduct(item)"
        >
          <div
            class="img-box"
            :style="[
              productId == item.id
                ? { background: '#E7EDFA' }
                : { background: '#F8F8F8' },
            ]"
          >
            <img
              :style="[
                productId == item.id
                  ? { background: '#E7EDFA' }
                  : { background: '#F8F8F8' },
              ]"
              :src="item.imagePath"
              alt=""
            />
          </div>
          <div
            class="product-name"
            :style="[productId == item.id ? { color: '#0A4DCC' } : {}]"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div> -->
    <rLogin :loginShow="loginShow" @handLogin="handLogin"></rLogin>
    <Modal width="480" v-model="modalTaximeter" footer-hide>
      <div class="taximeter-box">
        <div class="t-title">Price Calculator</div>
        <div class="t-subtitle">
          This price is <strong>only</strong> for reference, Final price shall be subjected to the saved order.
        </div>
        <div class="t-box">{{priceMsg?priceMsg.price:"0.00"}} <span>{{ priceMsg?priceMsg.moneyType:'' }}</span></div>
        <div
          class="taximeter-item common-flex common-align-center common-justify-between"
        >
          <div class="title">Order method</div>

          <Select
            class="taximeter-select"
            @on-select="selectOrdertype"
            v-model="paramsPrice.orderType"
            style="width: 200px"
          >
            <Option v-for="item in orderMethods" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>
        </div>
        <div
          class="taximeter-item common-flex common-align-center common-justify-between"
        >
          <div class="title">Category</div>
          <Select
            class="taximeter-select"
            @on-select="selectClothCode"
            v-model="paramsPrice.clothCode"
            style="width: 200px"
          >
            <Option v-for="item in categoryTaximeter" :value="item.ecode" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </div>
        <div
          class="taximeter-item common-flex common-align-center common-justify-between"
        >
          <div class="title">Lining type</div>
          <Select
            class="taximeter-select"
            v-model="paramsPrice.liningCode"
            style="width: 200px"
            :disabled="!paramsPrice.clothCode?true:false"
          >
            <Option v-for="item in lingList" :value="item.ecode" :key="item.ecode">{{
              item.name
            }}</Option>
          </Select>
        </div>
        <div
          class="taximeter-item common-flex common-align-center common-justify-between"
        >
          <div class="title">Fabric Number</div>
          <Select
          :disabled="!paramsPrice.clothCode?true:false"
          style="width: 200px"
            @on-change="changeFabri"
            clearable
            @on-query-change="queryChangeFabri"
            class="taximeter-select"
            :loading="fabricListSearch.length === 0"
            filterable
            allow-create
            loading-text="..."
          >
            <!-- :not-found-text="$t('noDate')" -->
            <!-- v-model="searchKey.fabric" -->
            <Option v-for="item in fabricListSearch" :value="item.fabricCode" :key="item.id">{{
              item.fabricCode
            }}</Option>
          </Select>
          <!-- <Select
            class="taximeter-select"
            v-model="paramsPrice.fabricCode"
            style="width: 200px"
          >
            <Option v-for="item in orderMethods" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select> -->
        </div>
        <div class="common-flex taximeter-btns">
          <Button class="back" @click="modalTaximeter = false">Back</Button>
          <Button class="submit" :loading="loading" @click="calculatePriceHeader">Calculate</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import rLogin from "./r-login";
import { mapActions } from "vuex";
import { getToken } from "../libs/util";

export default {
  name: "Header",
  components: {
    rLogin,
  },
  props: {
    failedNum: [Object, String],
  },
  data() {
    return {
      loading:false,
      priceMsg:'',
      value11: "",
      paramsPrice: {
        clothCode: "", //服装代码
        fabricCode: "", //面料代码
        liningCode: "", //衬里代码
        orderType: "", //订单类型
      },
      paramsPriceTip: {
        clothCode: "Please select cloth code", //服装代码
        fabricCode: "Please select fabric code", //面料代码
        liningCode: "Please select lining code", //衬里代码
        orderType: "Please select order type", //订单类型
      },
      orderMethods: [
        {
          value: "7",
          label: "Simple Order",
        },
        {
          value: "8",
          label: "Professional Order",
        },
      ],
      modalTaximeter: false,
      menuList: [],
      orderStatusList: [],
      orderStatus: "",
      visible: false,
      // 登录弹框
      loginShow: false,
      //   产品列表
      product: [
        // {
        //   name: "Trouser1",
        //   show: false,
        // }
      ],
      //   选择的产品id
      productId: 0,
      //   当前路由
      nowRouter: "",
      //   产品列表显示
      productShow: false,
      routerJumpNum: 0,
      productType: [
        // {
        //   name: this.$t("header.peofessionalOrder"),
        //   id: 1,
        // },
        // {
        //   name: this.$t("header.simpleOrder"),
        //   id: 2,
        // },
      ],
      //   选择的id
      productTypeId: "",
      categoryTaximeter: [],
      lingList: [],
      cateTaximeterId:'',
      fabricListSearch:[],
      fabricList: [],
      clothCategoryId:''
    };
  },
  watch: {
    $route: {
      handler(newRouter) {
        this.routerJumpNum++;
        this.nowRouter = "." + newRouter.path;
        // this.menuSet()
        if (this.$route.query.status == undefined) {
          this.orderStatus = "";
        } else {
          this.orderStatus = this.$route.query.status;
        }
        if (newRouter.path == "/" || this.routerJumpNum == 1) {
          this.getMemberAuthority();
        }
        this.$refs["poptipRef"] && this.$refs["poptipRef"][0].cancel();
      },
      immediate: true,
    },
    productTypeId: {
      handler(newVal) {
        if (newVal) {
          this.productId = "";
          this.getCategory();
        }
      },
      immediate: true,
    },
    // menus: {
    //   handler(newVal) {
    //     console.log('菜单列表',newVal)
    //   },
    //   immediate: true,
    // },
  },

  computed: {
    fullWidth() {
      return this.$store.state.fullWidth;
    },
    //  menus(){
    //    console.log('this.$store.state.user.menu',this.$store.state.user.menu)
    //   return this.$store.state.user.menu
    // }
  },
  mounted() {
    this.getStatus();
    // this.listDictSystem();
  },
  methods: {
    ...mapActions([
      "listDictSystemAction", //获得下单方式
      "getCategoryAction", //获得品类
      "getOrderSearchAction", //搜索项字典
      "getMemberAuthorityAction", //权限
      "loginoutAction", // 退出登录
      "selectDictBasicTreesAction", // 衬类型
      "zzFabricAction", // 面料搜索
      "calculatePriceHeaderAction", // 计算价格
    ]),
    resetModalData() {
      this.paramsPrice = {
        orderType: '',
        clothCode: '',
        liningCode: '',
        fabricCode: '',
      };
      this.priceMsg='';
    },
    calculatePriceHeader(){
      for(let key in this.paramsPriceTip){
        if(this.paramsPrice[key]==''){
          this.$Message.error(this.paramsPriceTip[key])
          return
        }
      }
      this.loading = true
      this.calculatePriceHeaderAction(this.paramsPrice).then(res=>{
        this.priceMsg = res.data
      }).finally(()=>{
        this.loading = false
      })
    },
    // 搜索面料
    queryChangeFabri(e) {
      this.zzFabricAction({
        clothCategory: this.cateTaximeterId,
        keywords: e,
      }).then((res) => {
        this.fabricListSearch = res.data;
      });
    },
    changeFabri(e){
      this.paramsPrice.fabricCode = e
    },
    selectClothCode(e) {
      console.log(e);
      this.categoryTaximeter.map(s=>{
        if(s.ecode==e.value){
          this.cateTaximeterId = s.id
        }
      })
      this.paramsPrice.liningCode = ''
      // this.paramsPrice.fabricCode = ''
      this.selectDictBasicTreesAction({
        category: e.value,
        orderType: this.paramsPrice.orderType
      }).then((res) => {
        console.log("衬类型", res);
        this.lingList = res.data;
      });
    },
    selectOrdertype(e) {
      this.getCategoryAction({
        orderWay: e.value,
      }).then((res) => {
        this.categoryTaximeter = res.data;
        this.paramsPrice.clothCode = "";
        this.cateTaximeterId = "";
        this.paramsPrice.liningCode = ''
      });
    },
    taximeter() {
      this.modalTaximeter = true;
      this.resetModalData();
    },
    // 获得权限
    getMemberAuthority() {
      this.menuList = [];
      this.menuList.push("home");
      this.getMemberAuthorityAction({
        authorityType: "MENU",
      }).then((res) => {
        res.data.map((item, index) => {
          // if(item.)
          this.menuList.push(item.code);
        });
        if (
          this.menuList.indexOf("newOrder") > -1 ||
          this.menuList.indexOf("peofessionalOrder") > -1
        ) {
          this.menuList.push("orders");
        }
        console.log(res.data);
        this.listDictSystem();
      });
    },
    // 设置菜单栏
    // menuSet(){
    //   this.menuList= []
    //   this.menuList.push('home')
    //   this.menus.map((item,index)=>{
    //     this.menuList.push(item.code)
    //   })
    //   if(this.menuList.indexOf('newOrder')>-1||this.menuList.indexOf('peofessionalOrder')>-1){
    //     this.menuList.push('orders')
    //   }
    // },
    // 修改当前的订单状态
    changeOrderStatus(e) {
      this.orderStatus = e.id;
      if (this.$route.name != "underProduction") {
        this.$router.push("./underProduction?status=" + e.id);
      } else {
        this.$router.push("./underProduction?status=" + e.id);
      }
    },
    // 获得状态
    getStatus() {
      this.getOrderSearchAction({ category: 9, type: 21 }).then((res) => {
        res.data.unshift({
          name: this.$t("all"),
          id: "",
        });
        this.orderStatusList = res.data;
      });
    },
    // 跳转购物车
    goCart() {
      this.$router.push("./saveItems");
    },
    // 获得品类
    getCategory() {
      this.getCategoryAction({
        orderWay: this.productTypeId,
      }).then((res) => {
        res.data.map((item) => {
          item.show = false;
        });
        this.product = res.data;
      });
    },
    listDictSystem() {
      if (this.$store.state.user.login) {
        this.listDictSystemAction({
          category: 7,
        }).then((res) => {
          res.data.map((item) => {
            if (item.id == 7) {
              item._code = "newOrder";
            } else if (item.id == 8) {
              item._code = "peofessionalOrder";
            }
          });
          res.data.map((item, index) => {
            if (this.menuList.indexOf(item._code) == -1) {
              res.data.splice(index, 1);
            }
          });
          let s = {
            id: 9,
            category: "7",
            zhName: "新下单",
            enName: "新下单",
            pos: 3,
            isStop: 0,
            name: "新下单",
          };
          res.data.push(s);
          this.productType = res.data;
          this.productTypeId = res.data[0].id;
          // console.log("下单方式", res);
        });
      }
    },
    logOut() {
      this.visible = false;
    },
    // 关闭
    handLogin() {
      this.loginShow = false;
    },

    // 跳转客户
    toUser() {
      if (this.$store.state.user.login) {
        this.$router.push("./user");
      } else {
        this.loginShow = true;
      }
      console.log(this.$store.state.user);
    },
    // 跳转消息中心
    message() {
      this.$router.push("./message");
    },
    //   选择类型
    chooseType(e) {
      this.productTypeId = e.id;
      // console.log("e", e);
      // if (e.id == 7) {
      //   this.$router.push("./newOrder");
      // } else {
      //   this.$router.push("./peofessionalOrder");
      // }
    },
    // 选择产品
    chooseProduct(e) {
      this.productId = e.id;
      if (this.productTypeId == 7) {
        this.$router.push({
          path: "./newOrder",
          query: {
            id: e.id,
          },
        });
      } else {
        sessionStorage.removeItem("plData");
        this.$router.push({
          path: "./peofessionalOrder",
          query: {
            id: e.id,
          },
        });
      }
      console.log(e);
    },
    //   跳转路由
    toRouter(e, index) {
      if (!getToken()) {
        this.loginShow = true;
        this.$Message.info("请先登录");
        return; // 未登录时直接返回，不执行跳转
      }
      
      if (index !== 1) {
        if ("link" !== e.type) {
          this.$router.push(e.router);
          if (e.router === "./underProduction") {
            this.orderStatus = "";
          }
        } else {
          window.open(e.router, "_blank");
        }
      }
    },
    enterProduct(e, index) {
      if (index == 1 && this.$store.state.user.login) {
        this.productShow = true;
      }
    },
    leaveProduct(e, index) {
      if (index == 1) {
        this.productShow = false;
      }
    },
    handleLoginout(name) {
      if (name === "loginout") {
        let that = this;
        this.$Modal.confirm({
          title: this.$t("user.outTips"),
          content: this.$t("user.logOut"),
          okText: this.$t("user.determine"),
          cancelText: this.$t("user.cancel"),
          onOk: () => {
            that.loginoutAction();
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.user {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background: #f8f8f8;
  // margin-top: 6px;
  display: block;
  margin-left: 30px;
}

.order-status-list {
  padding: 8px 0;
  cursor: pointer;
}

.header {
  position: relative;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.11);

  .content {
    // padding: 0 40px;
    width: 100%;
    height: 60px;
    min-width: 1440px;

    .logo {
      width: 139px;
      height: 60px;
      // margin: 0 50px 0 20px;
      // height: 35px;
      margin: 0 10px 0 40px;
    }

    .menus {
      .menu-item {
        padding: 0 20px;
        // margin-left: 50px;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 16px;
        // height: 60px;
        // line-height: 60px;
        position: relative;
        margin-top: 25px;
      }

      .menu-item-choose {
        color: #0a4dcc;
        font-weight: 500;
        position: relative;
      }

      .menu-item-line {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        width: 40px;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        background: #0a4dcc;
      }

      .menu-item-line::after {
        width: 0;
        height: 0;
        border-top: 4px solid #fff;
        border-left: 4px solid transparent;
        content: "";
        z-index: 9;
        position: absolute;
        // width: 4px;
        // height: 4px;
        bottom: 0;
        right: 0;
        // background: #fff;
      }

      .menu-item-line::before {
        content: "";
        z-index: 9;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 4px solid #fff;
        border-right: 4px solid transparent;
        left: 0;
        bottom: 0;
        // background: #fff;
      }
    }
  }
  .message-jjq {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
  .message {
    font-size: 18px;
    color: #134bb4;
  }

  .cart {
    font-size: 18px;
    color: #da8100;
    margin-left: 22px;
  }

  .header-product {
    width: 100%;
    // height: 336px;
    background: #fff;
    position: absolute;
    top: 60px;
    z-index: 9999;
    padding-top: 30px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.11);

    .product-type {
      > div {
        opacity: 0.7;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #081938;
        line-height: 16px;
        padding: 0 40px;
        height: 30px;
        line-height: 30px;
      }

      .product-typ-item {
        background: #e6edf9;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: #0a4dcc;
      }
    }

    .product-list {
      // width: 100%;
      width: 1320px;

      margin: 30px auto 0;

      // height: 200px;
      // overflow-x: auto;
      // overflow-y: hidden;
      .product-list-item {
        width: 150px;
        height: 200px;
        // overflow: hidden;
        margin: 0 7.5px;

        .img-box {
          width: 150px;
          height: 150px;

          //   background: #e7edfa;
          img {
            width: 104px;
            height: 104px;
            margin-top: 23px;
          }
        }

        .product-name {
          font-size: 14px;
          font-weight: Condensed;
          text-align: center;
          color: #081938;
          line-height: 16px;
          margin-top: 20px;
        }
      }
    }
  }
}

.header-product {
  width: 100%;
  // height: 336px;
  background: #fff;
  // position: absolute;
  // top: 60px;
  z-index: 9999;
  padding-top: 30px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.11);

  .product-type {
    > div {
      opacity: 0.7;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      color: #081938;
      line-height: 16px;
      padding: 0 40px;
      height: 30px;
      line-height: 30px;
    }

    .product-typ-item {
      background: #e6edf9;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #0a4dcc;
    }
  }

  .product-list {
    // width: 100%;
    width: 1320px;

    margin: 30px auto 0;

    // height: 200px;
    // overflow-x: auto;
    // overflow-y: hidden;
    .product-list-item {
      width: 150px;
      height: 200px;
      // overflow: hidden;
      margin: 0 7.5px;

      .img-box {
        width: 150px;
        height: 150px;
        //   background: #e7edfa;
        overflow: hidden;

        img {
          width: 104px;
          height: 104px;
          margin: 23px auto 0;
          display: block;
          // margin-top: 23px;
        }
      }

      .product-name {
        font-size: 14px;
        font-weight: Condensed;
        text-align: center;
        color: #081938;
        line-height: 16px;
        margin-top: 20px;
      }
    }
  }
}

/deep/ .ivu-badge-count {
  right: -15px;
}
.t-title {
  width: 300px;
  height: 37px;
  font-family: Times, Times;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
  line-height: 37px;
  text-align: left;
  font-style: normal;
}
.t-subtitle {
  width: 450px;
  height: 14px;
  font-family: Times, Times;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  text-align: left;
  font-style: normal;
}
.t-box {
  width: 420px;
  height: 96px;
  line-height: 96px;
  text-align: center;
  background: #e6edfa;
  margin: 32px auto 12px;
}
.taximeter-box {
  width: 420px;
  margin: 30px auto 0;
  font-family: Roboto, Roboto;
  font-weight: 900;
  font-size: 30px;
  color: #0a4dcc;
  line-height: 35px;
  text-align: left;
  font-style: normal;
  span {
    font-size: 16px;
    color: #666666;
  }
}
.taximeter-item {
  margin: 30px auto;
  border-bottom: 1px solid #081938;
  padding-bottom: 10px;
  .title {
    width: 170px;
    height: 20px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
  }
  .taximeter-select {
    /deep/.ivu-select-selection {
      border: none;
      box-shadow: none;
    }
  }
}
.taximeter-btns {
  margin: 60px auto 0;
  justify-content: center;
  .back {
    background: rgba(8, 25, 56, 0.3);
    cursor: pointer;
    width: 116px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    margin: 0 14px;
  }
  .submit {
    background: #0a4dcc;
    cursor: pointer;
    width: 116px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    margin: 0 14px;
  }
}
/deep/.ivu-select-disabled .ivu-select-selection{
  background: #f8f8f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue